export function validateOptionalNumberInputs(form) {
  const inputs = form.querySelectorAll('input[type="number"]:not([required])');
  let valid = true;

  inputs.forEach((input) => {
    const badInput = input.validity && input.validity.badInput;
    let value = input.value.trim();
    input.closest(".control-group").classList.remove("error");
    const to_remove = input.parentElement.querySelector(".help-inline");
    to_remove ? to_remove.remove() : null;

    if (value === "" && !badInput) return;

    value = value.replace(",", ".");

    if (
      isNaN(value) ||
      value === "-" ||
      value === "." ||
      value === "-." ||
      badInput
    ) {
      valid = false;
      input.closest(".control-group").classList.add("error");
      input.parentElement.insertAdjacentHTML(
        "beforeend",
        `<span class="help-inline"><strong>${gettext(
          "Wrong value format.",
        )}</strong></span>`,
      );
    }
  });

  return valid;
}

export default {
  validateOptionalNumberInputs,
};
